export default "__VITE_ASSET__aba09735__"